import { graphql } from "../__generated__/gql";

export const PLACEHOLDER_QUERY = graphql(`
  query PlaceHolder {
    locationCountry {
      countryId
    }
  }
`);

export const CPY_QUERY = graphql(`
  query CPY(
    $productClass: ProductClass!
    $servicesClass: ServicesClass!
    $productLevel: Int!
    $countryId: Int
    $productId: Int
    $yearMin: Int
    $yearMax: Int
  ) {
    data: countryProductYear(
      productClass: $productClass
      servicesClass: $servicesClass
      productLevel: $productLevel
      countryId: $countryId
      productId: $productId
      yearMin: $yearMin
      yearMax: $yearMax
    ) {
      countryId
      locationLevel
      productId
      productLevel
      year
      exportValue
      importValue
      exportRca
      isNew
      productStatus
      cog
      distance
    }
  }
`);

export const CCPY_QUERY = graphql(`
  query CCPY(
    $productClass: ProductClass!
    $servicesClass: ServicesClass!
    $productLevel: Int
    $countryId: Int
    $partnerCountryId: Int
    $productId: Int
    $yearMin: Int
    $yearMax: Int
  ) {
    data: countryCountryProductYear(
      productClass: $productClass
      servicesClass: $servicesClass
      productLevel: $productLevel
      countryId: $countryId
      partnerCountryId: $partnerCountryId
      productId: $productId
      yearMin: $yearMin
      yearMax: $yearMax
    ) {
      countryId
      locationLevel
      partnerCountryId
      partnerLevel
      productId
      productLevel
      year
      exportValue
      importValue
    }
  }
`);

export const GGPY_QUERY = graphql(`
  query GGPY(
    $productClass: ProductClass!
    $servicesClass: ServicesClass!
    $productLevel: Int
    $groupId: Int
    $partnerGroupId: Int
    $productId: Int
    $yearMin: Int
    $yearMax: Int
  ) {
    data: groupGroupProductYear(
      productClass: $productClass
      servicesClass: $servicesClass
      productLevel: $productLevel
      groupId: $groupId
      partnerGroupId: $partnerGroupId
      productId: $productId
      yearMin: $yearMin
      yearMax: $yearMax
    ) {
      groupId
      locationLevel
      partnerGroupId
      partnerType
      productId
      productLevel
      year
      exportValue
      importValue
    }
  }
`);

export const CGPY_QUERY = graphql(`
  query CGPY(
    $countryId: Int
    $productClass: ProductClass!
    $servicesClass: ServicesClass!
    $productLevel: Int
    $partnerGroupId: Int!
    $productId: Int
    $yearMin: Int
    $yearMax: Int
  ) {
    data: countryGroupProductYear(
      countryId: $countryId
      productClass: $productClass
      servicesClass: $servicesClass
      productLevel: $productLevel
      partnerGroupId: $partnerGroupId
      productId: $productId
      yearMin: $yearMin
      yearMax: $yearMax
    ) {
      countryId
      locationLevel
      partnerGroupId
      partnerLevel
      productId
      productLevel
      year
      exportValue
      importValue
    }
  }
`);

export const GCPY_QUERY = graphql(`
  query GCPY(
    $groupId: Int!
    $productClass: ProductClass!
    $servicesClass: ServicesClass!
    $productLevel: Int
    $partnerCountryId: Int
    $productId: Int
    $yearMin: Int
    $yearMax: Int
  ) {
    data: groupCountryProductYear(
      groupId: $groupId
      productClass: $productClass
      servicesClass: $servicesClass
      productLevel: $productLevel
      partnerCountryId: $partnerCountryId
      productId: $productId
      yearMin: $yearMin
      yearMax: $yearMax
    ) {
      groupId
      locationLevel
      partnerCountryId
      partnerLevel
      productId
      productLevel
      year
      exportValue
      importValue
    }
  }
`);

export const CCY_QUERY = graphql(`
  query CCY(
    $countryId: Int
    $yearMin: Int
    $yearMax: Int
    $servicesClass: ServicesClass!
    $productClass: ProductClass
  ) {
    data: countryCountryYear(
      countryId: $countryId
      yearMin: $yearMin
      yearMax: $yearMax
      servicesClass: $servicesClass
      productClass: $productClass
    ) {
      countryId
      partnerCountryId
      year
      exportValue
      importValue
    }
  }
`);

export const CCPY2_QUERY = graphql(`
  query CCPY2(
    $productClass: ProductClass!
    $servicesClass: ServicesClass!
    $productLevel: Int
    $countryId: Int
    $productId: Int
    $yearMin: Int
    $yearMax: Int
  ) {
    data: countryCountryProductYear(
      productClass: $productClass
      servicesClass: $servicesClass
      productLevel: $productLevel
      countryId: $countryId
      productId: $productId
      yearMin: $yearMin
      yearMax: $yearMax
    ) {
      countryId
      locationLevel
      partnerCountryId
      partnerLevel
      productId
      productLevel
      year
      exportValue
      importValue
    }
  }
`);

export const CGPY2_QUERY = graphql(`
  query CGPY2(
    $productClass: ProductClass!
    $servicesClass: ServicesClass!
    $productLevel: Int
    $partnerGroupId: Int!
    $productId: Int
    $yearMin: Int
    $yearMax: Int
  ) {
    data: countryGroupProductYear(
      productClass: $productClass
      servicesClass: $servicesClass
      productLevel: $productLevel
      partnerGroupId: $partnerGroupId
      productId: $productId
      yearMin: $yearMin
      yearMax: $yearMax
    ) {
      countryId
      locationLevel
      partnerGroupId
      partnerLevel
      productId
      productLevel
      year
      exportValue
      importValue
    }
  }
`);

export const GCPY2_QUERY = graphql(`
  query GCPY2(
    $productClass: ProductClass!
    $servicesClass: ServicesClass!
    $productLevel: Int
    $groupId: Int!
    $productId: Int
    $yearMin: Int
    $yearMax: Int
  ) {
    data: groupCountryProductYear(
      productClass: $productClass
      servicesClass: $servicesClass
      productLevel: $productLevel
      groupId: $groupId
      productId: $productId
      yearMin: $yearMin
      yearMax: $yearMax
    ) {
      groupId
      locationLevel
      partnerCountryId
      partnerLevel
      productId
      productLevel
      year
      exportValue
      importValue
    }
  }
`);
